import React, { ReactNode, type ReactElement } from 'react';
import { useDfContext } from '../context/df-context';
import { LoadingRing } from './loading-ring';
import Grid from './grid';

type ResultProps = {
  children: ReactNode;
  withoutGrid?: boolean;
  isProductPage?: boolean;
};

export default function Results({
  children,
  withoutGrid,
  isProductPage,
}: ResultProps): ReactElement | null {
  const {
    state: { results, productPageResults },
  } = useDfContext();

  const rederWrapper = (childComponent: ReactElement) => {
    if (withoutGrid) {
      return childComponent;
    }

    return <Grid>{childComponent}</Grid>;
  };

  if ((!results && !isProductPage) || (!productPageResults && isProductPage)) {
    return rederWrapper(
      <section className={`df-list-module-row`} aria-live="polite" aria-atomic="true">
        <LoadingRing />
      </section>,
    );
  }

  return children as ReactElement;
}
